import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

const Header = () => {
  return (
    <header className="hidden md:block  justify-center items-center px-16 py-1 w-full text-xs font-semibold text-red bg-gray-800 sm:px-5 sm:max-w-full">
      <div className="flex px-10 justify-between w-full max-w-[1001px] sm:flex-wrap sm:max-w-full">
        <div className='cursor-pointer text-white'>Ticket | Careers</div>
        <div className="flex gap-0.5 items-start whitespace-nowrap justify-center ">
          <div className="flex-auto cursor-pointer text-white"> <FontAwesomeIcon  icon={faEnvelope} /> business.deeze@gmail.com</div>
        </div>
      </div>
    </header>
  );
}

export default Header;
